define([], ()=> {
    return ['LocaleService', '$filter', (LocaleService, $filter)=> {
        return (amount)=> {
            let formatted;
            if (amount) {
                if (!amount.hasOwnProperty('amount')) {
                    console.error('Currency without amount was passed into currency filter!');
                }
                formatted = $filter('currency')(
                    amount.amount,
                    angular.isDefined(amount.currency) ? LocaleService.getCurrencySymbol(amount.currency) : LocaleService.getLocaleInfo().currency.symbol
                );
            }
            return formatted;
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/l10n/CurrencyFilter.js
 **/